
export const shopClasses = [
  {
    id: 1,
    title: 'Cocktail Fundamentals',
    level: 'Beginner',
    duration: '3 Hours',
    price: 189,
    spots: 8,
    image: 'https://public.readdy.ai/ai/img_res/8cac8d1d3a2f544273498ff82267782e.jpg',
    description: 'Master the essential techniques of cocktail making including shaking, stirring, and muddling.',
    includes: ['Welcome drink', 'Recipe booklet', 'Certificate'],
  },
  {
    id: 2,
    title: 'Advanced Mixology',
    level: 'Intermediate',
    duration: '4 Hours',
    price: 289,
    spots: 6,
    image: 'https://readdy.ai/api/search-image?query=advanced%20cocktail%20masterclass%20with%20sophisticated%20techniques%2C%20molecular%20mixology%2C%20smoke%20infusion%2C%20premium%20spirits%2C%20professional%20bartender%20demonstrating%2C%20elegant%20bar%20atmosphere%2C%20warm%20amber%20lighting&width=400&height=300&seq=class-glam-002&orientation=landscape',
    description: 'Explore advanced techniques including infusions, syrups, and molecular mixology.',
    includes: ['Premium spirits tasting', 'Advanced manual', 'Bar tools kit'],
  },
  {
    id: 3,
    title: 'Private One-on-One',
    level: 'All Levels',
    duration: '2 Hours',
    price: 449,
    spots: 1,
    image: 'https://readdy.ai/api/search-image?query=private%20bartending%20lesson%20one%20on%20one%20training%2C%20personal%20cocktail%20instruction%20intimate%20bar%20setting%2C%20professional%20mixologist%20teaching%20student%2C%20focused%20learning%20environment%2C%20luxury%20atmosphere&width=400&height=300&seq=class-glam-003&orientation=landscape',
    description: 'Personalized training tailored to your goals and skill level.',
    includes: ['Customized curriculum', 'Personal recipe book', 'Follow-up support'],
  },
  {
    id: 4,
    title: 'Hen\'s Party Experience',
    level: 'Groups',
    duration: '3 Hours',
    price: 159,
    spots: 12,
    image: 'https://readdy.ai/api/search-image?query=glamorous%20hens%20party%20bachelorette%20celebration%20with%20women%20making%20colorful%20cocktails%20together%2C%20pink%20and%20gold%20decorations%2C%20champagne%20glasses%2C%20fun%20festive%20atmosphere%2C%20elegant%20bar%20setting%20with%20confetti%20and%20celebration%20vibes%2C%20sophisticated%20ladies%20night%20out&width=400&height=300&seq=class-glam-hens&orientation=landscape',
    description: 'The ultimate hen\'s party experience! Learn to make signature cocktails with your besties.',
    includes: ['Champagne welcome', 'Party decorations', 'Photo opportunities'],
  },
  {
    id: 5,
    title: 'Home Bar Service',
    level: 'Private',
    duration: '2.5 Hours',
    price: 549,
    spots: 2,
    image: 'https://readdy.ai/api/search-image?query=romantic%20couple%20learning%20cocktail%20making%20at%20home%20with%20professional%20bartender%20instructor%2C%20intimate%20cozy%20home%20bar%20setting%2C%20elegant%20couple%20enjoying%20mixology%20lesson%20together%2C%20sophisticated%20date%20night%20experience%2C%20warm%20ambient%20lighting&width=400&height=300&seq=class-glam-couples&orientation=landscape',
    description: 'Bella comes to your home! Perfect for date nights, anniversaries, or learning together.',
    includes: ['In-home service', 'All equipment provided', 'Personalized recipes'],
  },
  {
    id: 6,
    title: 'Corporate Events',
    level: 'Groups',
    duration: '3 Hours',
    price: 119,
    spots: 20,
    image: 'https://readdy.ai/api/search-image?query=corporate%20team%20building%20cocktail%20event%2C%20business%20professionals%20making%20drinks%20together%2C%20fun%20group%20activity%2C%20modern%20event%20space%2C%20team%20collaboration%2C%20celebratory%20atmosphere%2C%20elegant%20setting&width=400&height=300&seq=class-glam-004&orientation=landscape',
    description: 'Perfect for team events, parties, and corporate gatherings.',
    includes: ['Group competition', 'Prizes', 'Catering options'],
  },
];

export const shopKits = [
  {
    id: 1,
    name: 'Essential Starter Kit',
    description: 'Everything a beginner needs to start crafting cocktails at home.',
    price: 169,
    originalPrice: 219,
    rating: 4.9,
    reviews: 234,
    tools: 12,
    ingredients: 8,
    badge: 'Best Seller',
    image: 'https://readdy.ai/api/search-image?query=premium%20cocktail%20bar%20tool%20kit%20flat%20lay%20photography%2C%20shaker%20jigger%20strainer%20muddler%20on%20marble%20surface%2C%20elegant%20bar%20accessories%2C%20professional%20bartending%20equipment%2C%20warm%20lighting%20product%20photography&width=400&height=400&seq=kit-glam-001&orientation=squarish',
  },
  {
    id: 2,
    name: 'Professional Bartender Set',
    description: 'Premium tools used by professional bartenders worldwide.',
    price: 329,
    originalPrice: 429,
    rating: 5.0,
    reviews: 156,
    tools: 24,
    ingredients: 12,
    badge: 'Pro Choice',
    image: 'https://readdy.ai/api/search-image?query=professional%20bartender%20tool%20set%20luxury%20presentation%2C%20gold%20and%20copper%20bar%20tools%2C%20premium%20cocktail%20making%20equipment%2C%20elegant%20gift%20box%20packaging%2C%20high-end%20bar%20accessories%20photography&width=400&height=400&seq=kit-glam-002&orientation=squarish',
  },
  {
    id: 3,
    name: 'Whiskey Cocktail Kit',
    description: 'Specialized kit for crafting perfect whiskey-based cocktails.',
    price: 229,
    originalPrice: 299,
    rating: 4.8,
    reviews: 189,
    tools: 10,
    ingredients: 15,
    badge: 'Specialty',
    image: 'https://readdy.ai/api/search-image?query=whiskey%20cocktail%20making%20kit%20with%20premium%20bourbon%20bottle%2C%20ice%20sphere%20mold%2C%20mixing%20glass%2C%20bitters%20collection%2C%20elegant%20dark%20wood%20presentation%2C%20luxury%20spirits%20gift%20set%20photography&width=400&height=400&seq=kit-glam-003&orientation=squarish',
  },
  {
    id: 4,
    name: 'Tropical Tiki Collection',
    description: 'Create exotic tiki drinks with authentic tools and ingredients.',
    price: 199,
    originalPrice: 259,
    rating: 4.7,
    reviews: 142,
    tools: 8,
    ingredients: 18,
    badge: 'Fun Pick',
    image: 'https://readdy.ai/api/search-image?query=tropical%20tiki%20cocktail%20kit%20with%20ceramic%20tiki%20mugs%2C%20bamboo%20accessories%2C%20exotic%20fruit%20syrups%2C%20colorful%20umbrella%20garnishes%2C%20fun%20summer%20bar%20set%20photography%2C%20vibrant%20tropical%20aesthetic&width=400&height=400&seq=kit-glam-004&orientation=squarish',
  },
  {
    id: 5,
    name: 'Molecular Mixology Set',
    description: 'Advanced kit for creating avant-garde cocktail experiences.',
    price: 389,
    originalPrice: 519,
    rating: 4.9,
    reviews: 87,
    tools: 20,
    ingredients: 25,
    badge: 'Advanced',
    image: 'https://readdy.ai/api/search-image?query=molecular%20mixology%20kit%20with%20scientific%20equipment%2C%20spherification%20tools%2C%20agar%20agar%2C%20sodium%20alginate%2C%20modern%20gastronomy%20bar%20set%2C%20futuristic%20cocktail%20making%20equipment%20photography&width=400&height=400&seq=kit-glam-005&orientation=squarish',
  },
];

export const shopManuals = [
  {
    id: 1,
    title: 'The Complete Cocktail Bible',
    recipes: 200,
    techniques: 50,
    pages: 320,
    price: 99,
    originalPrice: 129,
    badge: 'Bestseller',
    difficulty: 3,
    image: 'https://readdy.ai/api/search-image?query=elegant%20cocktail%20recipe%20book%20cover%20design%2C%20premium%20hardcover%20book%20with%20gold%20embossing%2C%20sophisticated%20dark%20background%2C%20professional%20mixology%20manual%2C%20luxury%20bar%20guide%20aesthetic&width=300&height=400&seq=manual-glam-001&orientation=portrait',
    description: 'The ultimate guide covering classic and modern cocktails with step-by-step instructions.',
  },
  {
    id: 2,
    title: 'Beginner\'s Bartending Guide',
    recipes: 50,
    techniques: 20,
    pages: 120,
    price: 49,
    originalPrice: 65,
    badge: 'Perfect Start',
    difficulty: 1,
    image: 'https://readdy.ai/api/search-image?query=beginner%20bartending%20book%20cover%2C%20friendly%20approachable%20design%2C%20colorful%20cocktail%20illustrations%2C%20starter%20guide%20aesthetic%2C%20clean%20modern%20book%20design%20with%20cocktail%20imagery&width=300&height=400&seq=manual-glam-002&orientation=portrait',
    description: 'Start your mixology journey with essential techniques and crowd-pleasing recipes.',
  },
  {
    id: 3,
    title: 'Advanced Molecular Mixology',
    recipes: 75,
    techniques: 35,
    pages: 180,
    price: 109,
    originalPrice: 149,
    badge: 'Pro Level',
    difficulty: 3,
    image: 'https://readdy.ai/api/search-image?query=molecular%20mixology%20book%20cover%2C%20scientific%20cocktail%20design%2C%20modern%20avant-garde%20aesthetic%2C%20smoke%20and%20spherification%20imagery%2C%20premium%20professional%20bartender%20guide&width=300&height=400&seq=manual-glam-003&orientation=portrait',
    description: 'Master cutting-edge techniques including spherification, foams, and infusions.',
  },
  {
    id: 4,
    title: 'Classic Cocktails Mastery',
    recipes: 100,
    techniques: 30,
    pages: 200,
    price: 79,
    originalPrice: 99,
    badge: 'New',
    difficulty: 2,
    image: 'https://readdy.ai/api/search-image?query=classic%20cocktails%20book%20cover%2C%20vintage%20elegant%20design%2C%20art%20deco%20style%2C%20timeless%20cocktail%20recipes%2C%20sophisticated%20retro%20bar%20guide%20aesthetic&width=300&height=400&seq=manual-glam-004&orientation=portrait',
    description: 'Perfect your technique with timeless recipes from the golden age of cocktails.',
  },
  {
    id: 5,
    title: 'Home Bar Setup Guide',
    recipes: 40,
    techniques: 15,
    pages: 80,
    price: 39,
    originalPrice: 49,
    badge: 'Essential',
    difficulty: 1,
    image: 'https://readdy.ai/api/search-image?query=home%20bar%20setup%20guide%20book%20cover%2C%20interior%20design%20aesthetic%2C%20bar%20cart%20styling%2C%20home%20entertaining%20guide%2C%20modern%20lifestyle%20book%20design&width=300&height=400&seq=manual-glam-005&orientation=portrait',
    description: 'Everything you need to create the perfect home bar setup.',
  },
  {
    id: 6,
    title: 'Seasonal Cocktails Collection',
    recipes: 80,
    techniques: 25,
    pages: 160,
    price: 59,
    originalPrice: 85,
    badge: 'Popular',
    difficulty: 2,
    image: 'https://readdy.ai/api/search-image?query=seasonal%20cocktails%20book%20cover%2C%20four%20seasons%20theme%2C%20colorful%20fresh%20ingredients%2C%20festive%20drink%20recipes%2C%20beautiful%20food%20photography%20style%20book&width=300&height=400&seq=manual-glam-006&orientation=portrait',
    description: 'Craft the perfect drink for every season with fresh, seasonal ingredients.',
  },
];

export const shopPackages = [
  {
    id: 1,
    name: 'The Starter Sparkle',
    tagline: 'Perfect for beginners ready to shine',
    classIncluded: 'Cocktail Fundamentals (3hrs)',
    kitIncluded: 'Essential Starter Kit',
    manualIncluded: 'Beginner\'s Bartending Guide',
    extras: ['Welcome champagne', 'Recipe card set', 'Certificate of completion'],
    originalPrice: 407,
    price: 279,
    savings: 128,
    badge: 'Most Popular',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20champagne%20gold%20cocktail%20starter%20kit%20with%20elegant%20shaker%20and%20crystal%20glasses%20arranged%20on%20black%20marble%20surface%20with%20gold%20leaf%20accents%20and%20soft%20warm%20bokeh%20lighting%2C%20premium%20product%20photography%2C%20glamorous%20aesthetic&width=500&height=600&seq=pkg-starter-001&orientation=portrait',
  },
  {
    id: 2,
    name: 'The Golden Hour',
    tagline: 'Elevate your craft to the next level',
    classIncluded: 'Advanced Mixology (4hrs)',
    kitIncluded: 'Professional Bartender Set',
    manualIncluded: 'The Complete Cocktail Bible',
    extras: ['Premium spirits tasting', 'Gold bar spoon engraved', 'VIP follow-up session', 'Lifetime recipe access'],
    originalPrice: 717,
    price: 489,
    savings: 228,
    badge: 'Best Value',
    image: 'https://readdy.ai/api/search-image?query=premium%20rose%20gold%20cocktail%20set%20with%20professional%20bartender%20tools%20and%20crystal%20mixing%20glass%20on%20dark%20velvet%20surface%20with%20rose%20petals%20and%20warm%20candlelight%2C%20luxury%20mixology%20equipment%2C%20glamorous%20feminine%20aesthetic&width=500&height=600&seq=pkg-golden-001&orientation=portrait',
  },
  {
    id: 3,
    name: 'The Diamond Experience',
    tagline: 'The ultimate luxury mixology journey',
    classIncluded: 'Private One-on-One (2hrs) + Advanced Mixology (4hrs)',
    kitIncluded: 'Molecular Mixology Set + Professional Set',
    manualIncluded: 'Complete 6-Manual Collection',
    extras: ['Private tasting dinner', 'Personalised cocktail menu', 'Lifetime mentorship access', 'Exclusive masterclass invites', 'Crystal cocktail glass set'],
    originalPrice: 1475,
    price: 899,
    savings: 576,
    badge: 'Exclusive',
    image: 'https://readdy.ai/api/search-image?query=ultra%20luxury%20diamond%20themed%20cocktail%20experience%20with%20crystal%20decanters%20and%20gold%20bar%20tools%20on%20black%20marble%20with%20diamond%20sparkle%20effects%20and%20champagne%20bubbles%2C%20opulent%20mixology%20setup%2C%20high%20end%20glamorous%20photography&width=500&height=600&seq=pkg-diamond-001&orientation=portrait',
  },
  {
    id: 4,
    name: 'Hen\'s Party Glam Package',
    tagline: 'Celebrate in style with the girls',
    classIncluded: 'Hen\'s Party Experience (3hrs, up to 12 guests)',
    kitIncluded: 'Tropical Tiki Collection',
    manualIncluded: 'Seasonal Cocktails Collection',
    extras: ['Champagne tower welcome', 'Party decorations included', 'Photo booth props', 'Personalised cocktail menu'],
    originalPrice: 617,
    price: 419,
    savings: 198,
    badge: 'Party Fave',
    image: 'https://readdy.ai/api/search-image?query=glamorous%20hens%20party%20cocktail%20setup%20with%20pink%20champagne%20tower%20and%20rose%20gold%20accessories%20on%20elegant%20table%20with%20confetti%20and%20sparkle%20decorations%2C%20feminine%20celebration%20aesthetic%2C%20luxury%20party%20photography&width=500&height=600&seq=pkg-hens-001&orientation=portrait',
  },
  {
    id: 5,
    name: 'Couples\' Date Night Luxe',
    tagline: 'Romance meets mixology at your home',
    classIncluded: 'Home Bar Service for Couples (2.5hrs)',
    kitIncluded: 'Whiskey Cocktail Kit',
    manualIncluded: 'Classic Cocktails Mastery',
    extras: ['Candlelit setup at your home', 'Personalised couple\'s recipe book', 'Premium ingredient hamper', 'Rose petal presentation'],
    originalPrice: 857,
    price: 579,
    savings: 278,
    badge: 'Romantic',
    image: 'https://readdy.ai/api/search-image?query=romantic%20couples%20cocktail%20making%20experience%20with%20two%20elegant%20coupe%20glasses%20and%20whiskey%20set%20on%20candlelit%20table%20with%20rose%20petals%20and%20warm%20ambient%20lighting%2C%20intimate%20luxury%20date%20night%20aesthetic%2C%20premium%20photography&width=500&height=600&seq=pkg-couples-001&orientation=portrait',
  },
];
